import { Component, OnInit, Input, SimpleChanges, OnChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-save-editions',
  templateUrl: './save-editions.component.html',
  styleUrls: ['./save-editions.component.scss']
})
export class SaveEditionsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() custumSubmit: boolean = false;
  @Input() clearForm: boolean = true
  @Input() form: FormGroup;
  @Input() date;
  @Input() lastChange = true;
  @Input() divider = true;
  @Input() progress;
  @Input() service;
  @Input() marginCustom;
  @Output() clickClearAlternateChanges = new EventEmitter();
  @Output() emitSubmit = new EventEmitter();

  public uploadDone = false;
  public last_change: Date;
  public changed_by:string;

  constructor() { }

  ngOnInit() {
    this.service?.tabChange.subscribe((response) => {
      if(response) {
        this.resetForm();
        this.checkForDifferentData();
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (typeof this.progress !== 'undefined') {
      if (this.progress > 0) {
        this.uploadDone = true;
      }
      if (this.progress === 100) {
        this.uploadDone = false;
      }
    }
    this.setLastChangesValues();
  }

  setLastChangesValues() {
    let changed_by = this.form.controls.changed_by;
    this.changed_by = changed_by ? changed_by.value : 'Valor padrão';
    let last_change = this.form.controls.last_change;
    this.last_change = last_change ? last_change.value : new Date();
  }

  restForm(e) {
    if (!e.disabled) {
      // this.form.markAsDirty({ onlySelf: false });
      // tslint:disable-next-line: forin
      this.resetForm();
      this.checkForDifferentData();
    }
  }

  private resetForm() : void {
    if (typeof this.date !== 'undefined' && this.clearForm){
      for (const key in this.date) {
          this.form.patchValue(
            this.date
          );
          this.form.reset(this.date);
      }
    }
  }

  private checkForDifferentData() {
    // tslint:disable-next-line: forin
    if (typeof this.service !== 'undefined') {
      for (const key in this.date) {
        if (this.date[key] !== this.form.value[key]) {
          this.service.setInterceptTabChange(false);
        } else {
          this.service.setInterceptTabChange(true);
        }
      }
    }
  }

  custumSubmitEvent() {
    this.emitSubmit.emit();
  }

  actionButtonOptional(param) {
    this.clickClearAlternateChanges.emit(param);
  }

  ngOnDestroy(): void {
    // Called once, before the instance is destroyed.
    // Add 'implements OnDestroy' to the class.
    // if (typeof this.service !== 'undefined') {
    //   this.service.makeChanges(false);
    // }
  }

}
